// extracted by mini-css-extract-plugin
module.exports = {"siteContainer":"defaultLayout-module--site-container--3vSwx","mainContainer":"defaultLayout-module--main-container--2yaMD"};